// Independent Coupon System - Correct Flow

// Add CSS styles for independent discount reminder
const independentStyles = `
.independent-discount-reminder-wrapper{
    margin: 0 auto;
    display: flex;
    flex-direction: row; 
    align-items: center; 
    justify-content: center; 
    gap: 20px;
    text-align: left;
}

.independent-discount-reminder-inner{
    display: flex; 
    flex-direction: row;
    justify-content: center; 
    font-size: 14px; opacity: 0.9;
}

.independent-discount-reminder-inner .independent-discount-reminder-main-text{
}

.independent-discount-reminder-inner .independent-discount-reminder-main-text strong{
}

.independent-discount-reminder-inner .independent-discount-reminder-main-discount-code{
    margin-left: 12px; 
    color: #ffbf00;
}

.independent-discount-reminder-close-button{
    padding: 5px 10px;
    background: rgba(255,255,255,0.2); 
    border: none; color: white;
    border-radius: 3px; 
    cursor: pointer;
}

@media (max-width: 1180px) {

    .independent-discount-reminder-inner{
        flex-direction: column;
        text-align: left;
    }

    .independent-discount-reminder-inner .independent-discount-reminder-main-discount-code {
        margin-left: 0;
    }

}

@media (max-width: 820px) {

}
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.textContent = independentStyles;
document.head.appendChild(styleSheet);

(function() {
    let isProcessing = false;

    // Check if user came from independent
    function isIndependentVisitor() {
        const urlParams = new URLSearchParams(window.location.search);
        const hasParam = urlParams.has("theindependent");
        
        // Also check for URL-encoded version due to malformed URL structure
        const urlString = window.location.href;
        const hasEncodedParam = urlString.includes("theindependent%3F") || urlString.includes("theindependent?");
        
        // SKIP if this is a RESTOCK15 user
        const isRestockUser = urlParams.has("RESTOCK15") || urlParams.has("restock15");
        
        console.log('🔍 URL Detection Debug:');
        console.log('  - Full URL:', urlString);
        console.log('  - Search params:', window.location.search);
        console.log('  - Has "theindependent" param:', hasParam);
        console.log('  - Has encoded param:', hasEncodedParam);
        console.log('  - Is RESTOCK15 user:', isRestockUser);
        
        // Don't interfere with RESTOCK15 users
        if (isRestockUser) {
            console.log('🚫 Skipping Independent system - this is a RESTOCK15 user');
            return false;
        }
        
        return hasParam || hasEncodedParam;
    }

    // Add discount parameter to any URL
    function addDiscountToUrl(url, discountCode) {
        try {
            const urlObj = new URL(url, window.location.origin);
            urlObj.searchParams.set('discount', discountCode);
            return urlObj.toString();
        } catch (error) {
            // Fallback for relative URLs
            const separator = url.includes('?') ? '&' : '?';
            return `${url}${separator}discount=${encodeURIComponent(discountCode)}`;
        }
    }

    // Apply coupon code to cart
    async function applyCouponToCart(couponCode) {
        console.log('🎯 Applying coupon to cart:', couponCode);
        
        try {
            // Method 1: Store in cart attributes
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { 
                        'discount_code': couponCode,
                        '_discount': couponCode,
                        'independent_coupon': couponCode,
                        'checkout_discount': couponCode
                    }
                })
            });

            // Method 2: Try direct discount application
            try {
                await fetch(`/discount/${couponCode}`, {
                    method: 'GET',
                    redirect: 'manual'
                });
            } catch (e) {
                console.log('Direct discount method attempted');
            }

            console.log('✅ Coupon applied to cart successfully');
            return true;
            
        } catch (error) {
            console.error('❌ Error applying coupon to cart:', error);
            return false;
        }
    }

    // Handle Independent button click
    async function handleIndependentButtonClick(button, redirectUrl) {
        if (isProcessing) return;
        isProcessing = true;

        console.log('🎯 Processing Independent button click...');
        
        // Show loading state
        const originalText = button.textContent;
        button.textContent = 'Applying coupon...';
        button.style.pointerEvents = 'none';

        try {
            // Step 1: Apply coupon to cart
            console.log('📝 Step 1: Applying coupon to cart...');
            const couponApplied = await applyCouponToCart('NMNBOOST25');
            
            if (couponApplied) {
                button.textContent = 'Coupon applied! Redirecting...';
                
                // Step 2: Wait a moment for the coupon to process
                console.log('⏳ Step 2: Waiting for coupon to process...');
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                // Step 3: Redirect to the href with discount parameter as backup
                console.log('🔄 Step 3: Redirecting to:', redirectUrl);
                const urlWithDiscount = addDiscountToUrl(redirectUrl, 'NMNBOOST25');
                
                // Analytics tracking
                if (typeof gtag !== 'undefined') {
                    gtag('event', 'independent_coupon_applied', {
                        'event_category': 'independent_campaign',
                        'event_label': 'coupon_applied_and_redirected',
                        'redirect_url': redirectUrl
                    });
                }
                
                window.location.href = urlWithDiscount;
            } else {
                // If coupon application failed, still redirect with URL parameter
                console.log('⚠️ Coupon application failed, redirecting with URL parameter...');
                button.textContent = 'Redirecting...';
                const urlWithDiscount = addDiscountToUrl(redirectUrl, 'NMNBOOST25');
                window.location.href = urlWithDiscount;
            }
            
        } catch (error) {
            console.error('❌ Error in Independent button handling:', error);
            // Fallback: redirect with discount in URL
            const urlWithDiscount = addDiscountToUrl(redirectUrl, 'NMNBOOST25');
            window.location.href = urlWithDiscount;
        } finally {
            // Reset button state (though user will be redirected)
            isProcessing = false;
        }
    }

    // Setup checkout button interception for pages with coupon in URL
    function interceptCheckoutButtons() {
        const urlParams = new URLSearchParams(window.location.search);
        const discountCode = urlParams.get('discount');
        
        if (!discountCode) return;

        console.log('🔗 Setting up checkout interception for discount:', discountCode);

        const checkoutSelectors = [
            '#checkout',
            '[href="/checkout"]',
            '[href*="checkout"]',
            '.checkout-button',
            '[data-checkout]',
            'button[name="goto_pp"]',
            'button[name="goto_gc"]',
            '[data-shopify="payment-button"]',
            '.shopify-payment-button__button'
        ];

        checkoutSelectors.forEach(selector => {
            const buttons = document.querySelectorAll(selector);
            buttons.forEach(button => {
                if (button.dataset.independentProcessed) return;
                button.dataset.independentProcessed = 'true';

                // For anchor tags, update href
                if (button.tagName.toLowerCase() === 'a') {
                    const originalHref = button.href || '/checkout';
                    button.href = addDiscountToUrl(originalHref, discountCode);
                    console.log('✅ Updated checkout link with discount');
                } else {
                    // For buttons, add click handler
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountCode)}`;
                        console.log('🛒 Redirecting to checkout with discount');
                        window.location.href = checkoutUrl;
                    });
                }
            });
        });
    }

    // Show discount reminder banner
    function showDiscountReminder() {
        const urlParams = new URLSearchParams(window.location.search);
        const discountCode = urlParams.get('discount');
        
        if (!discountCode || document.querySelector('#independent-discount-reminder')) return;

        const banner = document.createElement('div');
        banner.id = 'independent-discount-reminder';
        banner.style.cssText = `
            background: linear-gradient(135deg, #870058, #9F3379);
            color: white;
            padding: 12px 20px;
            text-align: center;
            position: sticky;
            top: 0;
            z-index: 9999;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        `;
        banner.innerHTML = `
            <div class="independent-discount-reminder-wrapper">
                <div class="independent-discount-reminder-inner">
                    <span class="independent-discount-reminder-main-text"><strong>Your 25% OFF discount is ready!</strong> Now you can add NAD+ Precursors to your cart.</span>
                    <div class="independent-discount-reminder-main-discount-code">Code: <strong>${discountCode}</strong> will apply at checkout</div>
                </div>
                <button class="independent-discount-reminder-close-button" onclick="this.parentElement.parentElement.remove()">×</button>
            </div>
        `;
        
        document.body.insertBefore(banner, document.body.firstChild);
    }

    // Main handler for Independent visitors
    function handleIndependentVisitor() {
        if (!isIndependentVisitor()) {
            console.log('❌ Not an Independent visitor');
            // Not a Independent visitor, but check if they have discount in URL
            showDiscountReminder();
            interceptCheckoutButtons();
            return;
        }

        console.log('🎯 Independent visitor detected!');
        console.log('🔍 Current URL:', window.location.href);

        // Function to show independent elements
        function showIndependentElements() {
            const independentElements = document.querySelectorAll('.landing-independent');
            console.log(`📱 Found ${independentElements.length} .landing-independent elements`);
            
            if (independentElements.length === 0) {
                console.log('⚠️ No .landing-independent elements found, will retry...');
                return false;
            }
            
            independentElements.forEach((element, index) => {
                console.log(`✅ Adding 'show' class to element ${index + 1}:`, element);
                element.classList.add('show');
            });

            // Setup click handlers for Independent links
            const independentLinks = document.querySelectorAll('.landing-independent a');
            console.log(`🔗 Found ${independentLinks.length} Independent links`);
            
            independentLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    const redirectUrl = this.getAttribute('href');
                    
                    if (!redirectUrl) {
                        console.error('❌ No href found on Independent link');
                        return;
                    }

                    console.log('🎯 Independent button clicked, processing...');
                    handleIndependentButtonClick(this, redirectUrl);
                });
            });

            // Analytics tracking for display
            if (typeof gtag !== 'undefined') {
                gtag('event', 'independent_offer_displayed', {
                    'event_category': 'independent_campaign',
                    'event_label': 'landing_independent_shown',
                    'elements_count': independentElements.length
                });
            }
            
            return true;
        }

        // Try immediately
        if (!showIndependentElements()) {
            // If no elements found, create them dynamically
            console.log('🔧 Creating .landing-independent elements dynamically...');
            createIndependentElements();
            
            // Try again after creating elements
            if (!showIndependentElements()) {
                console.log('❌ Failed to create or show independent elements');
            }
        }
        
        // Function to create independent elements dynamically
        function createIndependentElements() {
            // Find a good place to insert the independent offer
            const targetSelectors = [
                '.page-width',
                'main',
                '.main-content',
                '#MainContent',
                'body'
            ];
            
            let targetElement = null;
            for (const selector of targetSelectors) {
                targetElement = document.querySelector(selector);
                if (targetElement) break;
            }
            
            if (!targetElement) {
                console.error('❌ Could not find target element to insert independent offer');
                return;
            }
            
            // Create the independent offer element
            const independentOffer = document.createElement('div');
            independentOffer.className = 'landing-independent';
            independentOffer.style.cssText = `
                display: none;
                background: linear-gradient(135deg, #870058, #9F3379);
                color: white;
                padding: 40px 20px;
                text-align: center;
                margin: 20px 0;
                border-radius: 10px;
                box-shadow: 0 4px 20px rgba(0,0,0,0.1);
            `;
            
            independentOffer.innerHTML = `
                <div style="max-width: 600px; margin: 0 auto;">
                    <h3 style="font-size: 28px; margin-bottom: 15px; font-weight: bold;">
                        🎉 Exclusive 25% OFF for Independent Readers!
                    </h3>
                    <p style="font-size: 18px; margin-bottom: 25px; opacity: 0.9;">
                        Get premium NAD+ precursors with this special discount - only available through The Independent partnership
                    </p>
                    <a href="/collections/nad-precursors" 
                       style="display: inline-block; background: #ffbf00; color: #000; padding: 15px 30px; 
                              text-decoration: none; border-radius: 5px; font-weight: bold; font-size: 18px;
                              transition: all 0.3s ease; text-transform: uppercase;">
                        Shop Now with 25% OFF - Code: NMNBOOST25
                    </a>
                </div>
            `;
            
            // Add show/hide CSS
            const style = document.createElement('style');
            style.textContent = `
                .landing-independent.show {
                    display: block !important;
                    animation: fadeInUp 0.6s ease-out;
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `;
            document.head.appendChild(style);
            
            // Insert at the beginning of the target element
            targetElement.insertBefore(independentOffer, targetElement.firstChild);
            
            console.log('✅ Created independent offer element');
        }
    }

    // Initialize
    function initialize() {
        console.log('🚀 Initializing Independent coupon system...');
        
        handleIndependentVisitor();
        
        // Setup checkout interception if discount is in URL
        showDiscountReminder();
        interceptCheckoutButtons();
        
        // Re-run checkout interception periodically for dynamic content
        setInterval(() => {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('discount')) {
                interceptCheckoutButtons();
            }
        }, 5000);
        
        console.log('✅ Independent system ready!');
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

})();